// ต้องมาก่อนทุก import ที่ยิง API — ตั้ง activeCompanyId ของแท็บนี้จาก ?company=
// (แท็บที่ portal เปิดให้) ถ้าช้ากว่านี้ request ชุดแรกจะติด company_id ของบริษัทเดิม
import './services/companyBoot';
import React from 'react';
import ReactDOM from 'react-dom';
import { ModalProvider } from "react-modal-hook";
import './index.css';
import App from './App';
import { ContextProvider } from './contexts/ContextProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'resize-observer-polyfill/dist/ResizeObserver.global';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ถือว่า data fresh 30 วิ → ไม่ refetch ซ้ำถี่ ๆ
      // (realtime ยังมาจาก refetchInterval/websocket ที่ตั้งเฉพาะจุด ไม่กระทบ)
      staleTime: 30000,
      // เลิก refetch ทุกครั้งที่สลับแท็บกลับมา (ตัด "focus storm")
      refetchOnWindowFocus: false,
      // ลด retry จาก default 3 → 1 (กัน request ซ้ำ โดยเฉพาะตอนเจอ 429)
      retry: 1,
    },
  },
});


ReactDOM.render(
  <React.StrictMode>
      <QueryClientProvider client={queryClient}>
    <ContextProvider>
      <ModalProvider>
        <App />
      </ModalProvider>,
    </ContextProvider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
